import type { CSSProperties } from 'react'
import MaskedIcon from './MaskedIcon'

interface NavIconProps {
  src: string
  height?: number | string
  className?: string
  color?: string
  style?: CSSProperties
}

export default function NavIcon({ src, height = 25, className, color, style }: NavIconProps) {
  return (
    <MaskedIcon
      src={src}
      size={height}
      className={className}
      color={color}
      style={color ? style : { width: 'auto', height, objectFit: 'contain', ...style }}
    />
  )
}
